import React from 'react';
import { LayersIcon, FileTextIcon, RepeatIcon, ZapIcon, RefreshCwIcon } from 'lucide-react';
import { featureHighlights, features } from '../data/content';
import { SectionHeading } from './SectionHeading';
const icons = [LayersIcon, FileTextIcon, RepeatIcon, ZapIcon, RefreshCwIcon];
export function WhatYouGet() {
  return <section aria-labelledby="get-title" className="bg-paper" data-id="element-368" data-mp="q37kiv0tarf9">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-369" data-mp="1drgzbczlyeww">
        <SectionHeading id="get-title" title="Tout ce qu’il vous faut pour commencer à partager" intro="Avec le Pack Complet d’Évangélisation, vous recevez un accès numérique immédiat à :" data-id="element-370" data-mp="1duczz92ubhp1" />
        <div className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-371" data-mp="190s69t8a59vn">
          {featureHighlights.map(f => <div key={f.title} className="flex flex-col rounded-[28px] bg-cream p-8 sm:p-10" data-id="element-372" data-mp="1wqmkae4c54hh">
              <span className="font-display text-[80px] leading-[0.85] text-coral" data-id="element-373" data-mp="21i4nz9xqtj65">{f.value}</span>
              <h3 className="mt-4 text-xl font-extrabold uppercase tracking-[0.08em] text-navy" data-id="element-374" data-mp="2vfaqlcf37ngn">{f.title}</h3>
              <p className="mt-3 leading-relaxed text-ink-soft" data-id="element-375" data-mp="2qhiojpkqakyq">{f.text}</p>
            </div>)}
        </div>
        <ul className="mt-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-5" data-id="element-376" data-mp="356f3m6l7cy8u">
          {features.map((f, i) => {
          const Icon = icons[i];
          return <li key={f.title} data-id="element-377" data-mp="3e5sdh0d8nou3" data-mpi={i}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-leaf-wash text-leaf-deep" data-id="element-378" data-mp="3e4qr3zqrvfx2">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-379" data-mp="399bgrhrz425e" />
                </span>
                <h3 className="mt-4 font-extrabold uppercase tracking-[0.06em] text-navy" data-id="element-380" data-mp="3o3q2vr6u3roa">{f.title}</h3>
                <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-381" data-mp="3j66bdpl4liee">
                  {f.text}
                  {f.strong && <strong className="font-bold text-navy" data-id="element-382" data-mp="1tsksm418sgzz"> {f.strong}</strong>}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}